import Input from 'components/form/Inputs/Input';
import { FC } from 'react';
import StatsContainer from './StatsContainer';
import StatItemContainer from './StatsItemContainer';

export type MentorStatsType = {
  wantedMentorship: number | undefined;
  assignedMentorship: number | undefined;
  finishedMentorship: number | undefined;
  interruptedMentorship: number | undefined;
  lateMentorship: number | undefined;
};
const MentorStats: FC<MentorStatsType> = ({
  wantedMentorship,
  assignedMentorship,
  finishedMentorship,
  interruptedMentorship,
  lateMentorship,
}) => {
  return (
    <StatsContainer>
      <StatItemContainer>
        <p>Mentorés souhaités</p>
        <Input
          value={typeof wantedMentorship === 'number' ? wantedMentorship : ''}
          variant="disabled"
          readOnly
        />
      </StatItemContainer>
      <StatItemContainer>
        <p>En cours</p>
        <Input
          value={
            typeof assignedMentorship === 'number' ? assignedMentorship : ''
          }
          variant="disabled"
          readOnly
        />
      </StatItemContainer>
      <StatItemContainer>
        <p>Terminés</p>
        <Input
          value={
            typeof finishedMentorship === 'number' ? finishedMentorship : ''
          }
          variant="disabled"
          readOnly
        />
      </StatItemContainer>
      <StatItemContainer>
        <p>Interrompus</p>
        <Input
          value={
            typeof interruptedMentorship === 'number'
              ? interruptedMentorship
              : ''
          }
          variant="disabled"
          readOnly
        />
      </StatItemContainer>
      <StatItemContainer>
        <p>En retard</p>
        <Input
          value={typeof lateMentorship === 'number' ? lateMentorship : ''}
          variant="disabled"
          readOnly
        />
      </StatItemContainer>
    </StatsContainer>
  );
};

export default MentorStats;
